export const SMART_SAVE_ENABLED_SWITCH_CONTROLLED_APPLIANCE_TYPES = ['load_hot_water', 'load_hot_water_solar'];
